import React, { useEffect, useState, useRef, } from 'react';
import {
    Box,
    Typography,
    IconButton,
    Avatar,
    Grid,
    Modal,
    Badge,
    Popover,
    List,
    ListItem,
    ListItemText,
    Divider,
    Paper, useTheme, useMediaQuery
} from '@mui/material';
import { Notifications, Close } from '@mui/icons-material';
import hrmsDashboardImage from '../../../../src/assets/Hmrs_Hashstack.png'
// import p1 from "../../assets/p1.avif";
import axios from 'axios';
import { localAxiosGet, axiosInstance } from '../../../Axios/axios';
import EditProfile from '../../../components/EditProfile';
import TokenExpirePopup from '../../../components/TokenExpirePopup';
import { useNavigate } from 'react-router-dom';
import AttendanceTimerWithoutTimers from '../../../components/AttendanceTimerWithoutTimers';
import { Menu as MenuIcon } from '@mui/icons-material';
import PushNotificationManager from '../../../components/PushNotificationPrompt';

export const Header = ({ showMobileMenu = false, onMenuToggle }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const [currentDate, setCurrentDate] = useState('');
    const [userDetails, setUserDetails] = useState('');
    const accessToken = localStorage.getItem('accessToken');
    const [status, setStatus] = useState('OUT');
    const userId = localStorage.getItem('userId');
    const [EditProfileOpen, setIsEditProfileOpen] = useState(false);
    const [openTokenExpirePopup, setOpenTokenExpirePopup] = useState(false);
    const [notificationCount, setNotificationCount] = useState(0);
    const [notifications, setNotifications] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();
    const [showNotificationPrompt, setShowNotificationPrompt] = useState(false);

    useEffect(() => {
        const date = new Date();
        const formattedDate = `${String(date.getDate()).padStart(2, '0')} - ${String(date.getMonth() + 1).padStart(2, '0')} - ${date.getFullYear()}`;
        setCurrentDate(formattedDate);
    }, []);

    // useEffect(() => {

    //     if (userId === 66) {

    //         const timer = setTimeout(() => {
    //             setShowNotificationPrompt(true);               
    //         }, 3000); // Show after 3 seconds of page load

    //         return () => clearTimeout(timer);
    //     }
    // }, [userId]);

    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                const response = await axiosInstance(localAxiosGet(`/organization/getUserDetailsByUserId?userId=${userId}`, accessToken));
                if (response.data.status === "SUCCESS") {
                    setUserDetails(response.data.message.user);
                    localStorage.setItem('userDetailsStorage', JSON.stringify(response.data.message.user));
                    localStorage.setItem('departmentId', response.data.message.user.department_id);
                    console.log('userDetails', JSON.stringify(userDetails));
                }
            } catch (error) {
                console.log('Error in Fetching User details', error);
                if (error.response && error.response.status === 403) {
                    setOpenTokenExpirePopup(true);
                }
            }
        }

        fetchUserDetails();
    }, []);


    useEffect(() => {
        const fetchNotificationCount = async () => {
            if (!userId) {
                console.log('User ID not available');
                return;
            }

            try {
                const response = await axiosInstance(localAxiosGet(`/notifications/count?user_id=${userId}`, accessToken));
                if (response.data.status === "SUCCESS") {
                    setNotificationCount(response.data.message.count);
                }
            } catch (error) {
                console.log('Error fetching notification count:', error);
                if (error.response && error.response.status === 403) {
                    setOpenTokenExpirePopup(true);
                }
            }
        };

        fetchNotificationCount();
        const intervalId = setInterval(fetchNotificationCount, 30 * 60 * 1000);
        return () => clearInterval(intervalId);
    }, [userId, accessToken]);


    const fetchNotifications = async () => {
        if (!userId) return;

        try {
            const response = await axiosInstance(localAxiosGet(`/notifications/getNotifications?userId=${userId}`, accessToken));
            if (response.data.status === "SUCCESS") {
                setNotifications(response.data.message);
            }
        } catch (error) {
            console.log('Error fetching notifications:', error);
            if (error.response && error.response.status === 403) {
                setOpenTokenExpirePopup(true);
            }
        }
    };


    const markNotificationAsRead = async (notificationId) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${axiosInstance.defaults.baseURL}/notifications/mark-read`,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                data: {
                    notification_ids: [notificationId]
                }
            });

            if (response.data.status === "SUCCESS") {

                setNotifications(prevNotifications =>
                    prevNotifications.map(notification =>
                        notification.id === notificationId
                            ? { ...notification, is_read: true, read_at: new Date().toISOString() }
                            : notification
                    )
                );


                setNotificationCount(prevCount => Math.max(0, prevCount - 1));
            }
        } catch (error) {
            console.log('Error marking notification as read:', error);
        }
    };


    const handleNotificationClick = (event) => {
        setAnchorEl(event.currentTarget);
        fetchNotifications();
    };


    const handleNotificationClose = () => {
        setAnchorEl(null);
    };


    const handleNotificationItemClick = (notificationId, isRead) => {
        if (!isRead) {
            markNotificationAsRead(notificationId);
        }
    };


    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };


    const getSenderName = (notification) => {

        if (notification.sender_name) {
            return notification.sender_name;
        }


        if (notification.sender_first_name && notification.sender_last_name) {
            return `${capitalizeFirstChar(notification.sender_first_name)} ${capitalizeFirstChar(notification.sender_last_name)}`;
        }


        return notification.sender_type;
    };


    const getSenderInitials = (notification) => {

        if (notification.sender_first_name && notification.sender_last_name) {
            return `${notification.sender_first_name.charAt(0)}${notification.sender_last_name.charAt(0)}`;
        }


        if (notification.sender_name) {
            const nameParts = notification.sender_name.split(' ');
            if (nameParts.length > 1) {
                return `${nameParts[0].charAt(0)}${nameParts[1].charAt(0)}`;
            }
            return notification.sender_name.charAt(0);
        }


        return notification.sender_type.charAt(0);
    };

    function capitalizeFirstChar(str) {
        if (!str) {
            return "";
        }
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    const handleEditProfile = () => {
        setIsEditProfileOpen(true)
    }

    const handleEditProfileClose = () => {
        setIsEditProfileOpen(false)
    }

    const handleCloseTokenExpirePopup = () => {
        setOpenTokenExpirePopup(false);
        navigate('/');
    };

    const open = Boolean(anchorEl);
    const id = open ? 'notification-popover' : undefined;

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                p: { xs: "8px 16px", sm: "12px 24px", md: "12px 30px" },
                bgcolor: "#34495E",
                color: "#ECF0F1",
                minHeight: { xs: "60px" },
                position: 'relative',
                top: 0
            }}
        >
            <Grid container alignItems="center" spacing={1}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: { xs: 1, sm: 2 },
                    flex: 1,
                    overflow: 'hidden'
                }}>
                    {showMobileMenu && (
                        <>
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                edge="start"
                                onClick={onMenuToggle}
                                sx={{
                                    mr: 1,
                                    display: { xs: 'flex', md: 'none' }
                                }}
                            >
                                <MenuIcon />
                            </IconButton>


                            {/* HRMS Logo */}
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                mr: { xs: 1, sm: 2 }
                            }}>
                                <img
                                    src={hrmsDashboardImage}
                                    alt="HRMS Logo"
                                    style={{
                                        width: "40px",
                                        height: "auto",
                                        maxWidth: "40px",
                                    }}
                                />
                            </Box>
                        </>
                    )}

                    {/* Welcome Message - Stacked on mobile */}
                    <Box sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column' },
                        alignItems: { xs: 'flex-start' },
                        gap: { xs: 0, sm: 1 },
                        overflow: 'hidden'
                    }}>
                        <Typography
                            variant={isMobile ? "subtitle1" : "h6"}
                            sx={{
                                color: "white",
                                fontSize: { xs: "0.9rem", sm: "1.1rem", md: "1.25rem" },
                                fontWeight: "600",
                                lineHeight: 1.2,
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}
                        >
                            {isMobile ? "Welcome Back!" : `Welcome Back, ${capitalizeFirstChar(userDetails.first_name)} ${capitalizeFirstChar(userDetails.last_name)}`}
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                color: 'rgba(255, 255, 255, 0.7)',
                                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {currentDate}
                        </Typography>
                    </Box>
                </Box>


                {/* Right Side - Actions */}
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: { xs: 1, sm: 2 },
                    ml: 'auto'
                }}>
                    {/* Attendance Timer - Hide on mobile */}
                    {/* {!isMobile && ( */}
                    <AttendanceTimerWithoutTimers status={status} setStatus={setStatus} />
                    {/* )} */}

                    {/* Notifications */}
                    <IconButton
                        sx={{
                            color: "white",
                            p: { xs: 0.5, sm: 1 }
                        }}
                        onClick={handleNotificationClick}
                        aria-describedby={id}
                    >
                        <Badge
                            badgeContent={notificationCount}
                            color="error"
                            sx={{
                                '& .MuiBadge-badge': {
                                    backgroundColor: '#ff0000',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    fontSize: { xs: '0.6rem', sm: '0.75rem' }
                                }
                            }}
                        >
                            <Notifications sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }} />
                        </Badge>
                    </IconButton>


                    {/* Status Box - Compact on mobile */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: "#1ABC9C",
                            borderRadius: 2,
                            p: { xs: 0.5, sm: 2 },
                            color: "#FFFFFF",
                            fontSize: { xs: '0.75rem', sm: '0.875rem' },
                            // minWidth: { xs: 'auto', sm: '80px' }
                        }}
                    >
                        {isMobile ? (status === 'Punched In' ? 'In' : 'Out') : status}
                    </Box>
                    {/* Show notification prompt when user is logged in */}
                    {userId && <PushNotificationManager userId={userId} />}

                    {/* Profile Avatar */}
                    <IconButton sx={{ color: "white", p: { xs: 0.5, sm: 1 } }}>
                        <Avatar
                            sx={{
                                bgcolor: "#0D47A1",
                                width: { xs: 35, sm: 40 },
                                height: { xs: 35, sm: 40 },
                                fontSize: { xs: '0.8rem', sm: '1rem' },
                                fontWeight: 'bold',
                                borderRadius: "50%"
                            }}
                            onClick={handleEditProfile}
                        >
                            {userDetails.first_name?.charAt(0).toUpperCase()}
                            {userDetails.last_name?.charAt(0).toUpperCase()}
                        </Avatar>
                    </IconButton>
                </Box>
            </Grid>

            {/* Mobile Attendance Timer - Show below main content */}
            {/* {isMobile && (
            <Box sx={{ 
                position: 'absolute', 
                bottom: '-40px', 
                left: '50%', 
                transform: 'translateX(-50%)',
                zIndex: 1000,
                bgcolor: 'rgba(52, 73, 94, 0.95)',
                borderRadius: '20px',
                p: 1,
                backdropFilter: 'blur(10px)'
            }}>
                <AttendanceTimerWithoutTimers status={status} setStatus={setStatus} />
            </Box>
        )} */}

            {/* Edit Profile Modal */}
            <Modal
                open={EditProfileOpen}
                onClose={handleEditProfileClose}
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: '95%', sm: '80%', md: '70%' },
                    maxWidth: 800,
                    bgcolor: 'background.paper',
                    border: '1px solid #000',
                    boxShadow: 24,
                    p: { xs: 2, sm: 3, md: 4 },
                    borderRadius: 8,
                    maxHeight: '90vh',
                    overflowY: 'auto'
                }}>
                    <EditProfile onClose={handleEditProfileClose} />
                </Box>
            </Modal>

            {/* Token Expire Modal */}
            <Modal
                open={openTokenExpirePopup}
                onClose={handleCloseTokenExpirePopup}
                aria-labelledby="token-expire-modal-title"
                aria-describedby="token-expire-modal-description"
            >
                <TokenExpirePopup onClose={handleCloseTokenExpirePopup} />
            </Modal>

            {/* Notification Popover - width adjustment */}
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleNotificationClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps={{
                    style: {
                        width: '350px',
                        maxWidth: 'calc(100vw - 40px)',
                        maxHeight: '450px',
                        borderRadius: '8px',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                        overflow: 'hidden'
                    }
                }}
            >
                <Box sx={{ p: 2, bgcolor: '#3498DB', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold' }}>
                            Notifications
                        </Typography>
                        <IconButton size="small" sx={{ color: 'white' }} onClick={handleNotificationClose}>
                            <Close fontSize="small" />
                        </IconButton>
                    </Box>
                </Box>

                <List sx={{ p: 0, maxHeight: '400px', overflowY: 'auto' }}>
                    {notifications.length === 0 ? (
                        <Box sx={{ p: 3, textAlign: 'center' }}>
                            <Typography variant="body1" color="textSecondary">
                                No notifications to display
                            </Typography>
                        </Box>
                    ) : (
                        notifications.map((notification, index) => (
                            <React.Fragment key={notification.id}>
                                <ListItem
                                    button
                                    alignItems="flex-start"
                                    onClick={() => handleNotificationItemClick(notification.id, notification.is_read)}
                                    sx={{
                                        p: 2,
                                        backgroundColor: notification.is_read ? 'white' : '#dbeafe',
                                        transition: 'background-color 0.3s',
                                        borderLeft: notification.is_read ? 'none' : '4px solid #3498DB',
                                        '&:hover': {
                                            backgroundColor: notification.is_read ? '#f9f9f9' : '#bfdbfe'
                                        }
                                    }}
                                >
                                    <Box sx={{ display: 'flex', width: '100%' }}>
                                        <Box
                                            sx={{
                                                width: 40,
                                                height: 40,
                                                borderRadius: '50%',
                                                bgcolor: '#3498DB',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: 'white',
                                                fontWeight: 'bold',
                                                mr: 2
                                            }}
                                        >
                                            {getSenderInitials(notification)}
                                        </Box>
                                        <Box sx={{ flex: 1 }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#2c3e50' }}>
                                                    {getSenderName(notification)}
                                                </Typography>
                                                <Typography variant="caption" color="textSecondary">
                                                    {formatDate(notification.createdAt)}
                                                </Typography>
                                            </Box>
                                            <Typography variant="body2" sx={{
                                                color: '#34495e',
                                                fontWeight: notification.is_read ? 'normal' : 'medium'
                                            }}>
                                                {notification.message}
                                            </Typography>
                                            <Typography variant="caption" sx={{ color: '#7f8c8d', mt: 0.5, display: 'block' }}>
                                                Type: {notification.type.replace(/_/g, ' ')}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </ListItem>
                                {index < notifications.length - 1 && <Divider />}
                            </React.Fragment>
                        ))
                    )}
                </List>
            </Popover>
        </Box>
    );
};